import { notifications } from '@mantine/notifications';

import { Task } from '@/types/types';

type TFunction = (key: string, options?: Record<string, unknown>) => string;

/**
 * Surfaces a brief toast listing the dependent tasks a cascade reschedule
 * touched, so a drag/resize that moves other tasks isn't silent.
 */
export const showCascadeToast = (cascadedTasks: Pick<Task, 'name'>[] | undefined, t: TFunction) => {
  if (!cascadedTasks || cascadedTasks.length === 0) return;

  const names = cascadedTasks.map((task) => task.name);

  notifications.show({
    title: t('cascade_toast_title'),
    message:
      names.length === 1
        ? t('cascade_toast_message_one', { name: names[0] })
        : t('cascade_toast_message_other', { count: names.length, names: names.join(', ') }),
    color: 'blue',
  });
};
